import isMobile from './mobile';
/** Detect desktop browser */
export default function isDesktop(ua) {
	return !isMobile(ua);
}
